/**
 * userDataService — kimlik (kullanici) verisi icin SQL-only adaptor (Faz A).
 *
 * Backend: gts_auth_api (`GET /api/Auth/user/{firebaseUid}`) — `authApi` client
 *          (X-Company-Id + Authorization interceptor'dan otomatik).
 *
 * Kaynak: SystemUsers (Ana DB / MainDbContext). Kimlik icin tenant DB kullanilmaz.
 *
 * KRITIK: kullanicinin kanonik kimligi Firebase Auth UID'dir (= SystemUser.FirebaseUid).
 *         Bu yuzden `UserData.id = firebaseUid`.
 *
 * Eski Cloud Function `getUserData` ve dogrudan RTDB `/users/{uid}` okumalarinin
 * yerini alir. CF + RTDB fallback Faz A'da kaldirilir.
 */

import { authApi } from '../../config/apiClient';
import type { UserData } from '../FirebaseDataService';

/** SQL auth yanitini (camelCase) UserData sekline maple. */
function mapSqlUser(u: any): UserData {
  if (!u) return u;
  return {
    id: u.firebaseUid ?? u.id ?? undefined,
    email: u.email ?? '',
    firstName: u.firstName ?? undefined,
    lastName: u.lastName ?? undefined,
    companyId: u.companyId ?? undefined,
    companyName: u.companyName ?? undefined,
    role: u.role ?? 'user',
    branchesId: u.branchesId ?? undefined,
    employeeId: u.employeeId ?? undefined,
    photoURL: u.photoURL ?? u.profileImageUrl ?? undefined,
    // UserData.createdAt: number. SQL ISO string -> epoch ms.
    createdAt: u.createdAt ? new Date(u.createdAt).getTime() : undefined,
    kvkkAccepted: u.kvkkAccepted ?? undefined,
  };
}

/**
 * Tek kullaniciyi FirebaseUid ile getirir (SADECE SQL — GET /api/Auth/user/{uid}).
 * Bulunamazsa null.
 */
export async function getUserByUid(uid: string): Promise<UserData | null> {
  if (!uid) return null;
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log('[SOURCE:SQL] getUserByUid', uid);
  }
  const res = await authApi.get(`/api/Auth/user/${encodeURIComponent(uid)}`);
  const data = res.data?.data ?? res.data?.Data;
  return data ? mapSqlUser(data) : null;
}
